import React from 'react';
import { Card } from '../../../components';

const CardMessages = ({
  title,
  total,
  totalCustom,
  total7Days,
  total7DaysCustom,
  totalPrazoPerdidoDays,
  totalPrazoPerdidoDaysCustom,
  total3Days,
  total3DaysCustom
}) => (
  <Card className="dashboard-card dashboard-card--comunication">
    <h2>
      Mensagens 
      {' '}
      <strong>{title}</strong>
    </h2>
    <div className="dashboard-card-item">
      <div className="count">{total3Days}</div>
      <div className="description">
        Mensagens no Status com disparo em até 
        {' '}
        <strong>3 dias</strong>
      </div>
    </div>
    <div className="dashboard-card-item">
      <div className="count gray">{total3DaysCustom}</div>
      <div className="description">
        com filtros 
        {' '}
        <strong>personalizados</strong>
      </div>
    </div>
    <div className="dashboard-card-item">
      <div className="count">{total7Days}</div>
      <div className="description">
        Mensagens no Status com disparo em até 
        {' '}
        <strong>7 dias</strong>
      </div>
    </div>
    <div className="dashboard-card-item">
      <div className="count gray">{total7DaysCustom}</div>
      <div className="description">
        com filtros 
        {' '}
        <strong>personalizados</strong>
      </div>
    </div>
    <div className="dashboard-card-item">
      <div className="count">{totalPrazoPerdidoDays}</div>
      <div className="description">
        Mensagens no Status com  
        {' '}
        <strong>prazo perdido</strong>
      </div>
    </div>
    <div className="dashboard-card-item">
      <div className="count gray">{totalPrazoPerdidoDaysCustom}</div>
      <div className="description">
        com filtros 
        {' '}
        <strong>personalizados</strong>
      </div>
    </div>
    <div className="dashboard-card-item">
      <div className="count">{total}</div>
      <div className="description">Total de mensagens no status</div>
    </div>
    <div className="dashboard-card-item">
      <div className="count gray">{totalCustom}</div>
      <div className="description">
        com filtros 
        {' '}
        <strong>personalizados</strong>
      </div>
    </div>
  </Card>
);

export default CardMessages;



// WEBPACK FOOTER //
// ./src/screens/admin/Dashboard/card-communication.js